// Personal profile — change these values to your own.
export const PROFILE = {
  firstName: "Ovidiu",
  tagline: "Explorer of the spirit",
  email: "stefanovidiu29@yahoo.com",
  location: "On the road, always",
  socials: {
    instagram: "https://www.instagram.com/stefanoviddiu/",
    youtube: "https://www.youtube.com/@stefanovidiu98",
  },
};

// Home — origin point (shown as a special pin on the globe).
export const HOME = { name: "Bucharest, Romania (home)", lat: 44.4268, lng: 26.1025 };

// Visited places — shown as golden pins on the 3D globe.
export const VISITED = [
  { name: "Berlin, Germany", lat: 52.5200, lng: 13.4050 },
  { name: "Prague, Czech Republic", lat: 50.0755, lng: 14.4378 },
  { name: "Dublin, Ireland", lat: 53.3498, lng: -6.2603 },
  { name: "Alicante, Spain", lat: 38.3452, lng: -0.4810 },
  { name: "Copenhagen, Denmark", lat: 55.6761, lng: 12.5683 },
  { name: "Knokke-Heist, Belgium", lat: 51.3500, lng: 3.2900 },
  { name: "Milan, Italy", lat: 45.4642, lng: 9.1900 },
  { name: "Zurich, Switzerland", lat: 47.3769, lng: 8.5417 },
  { name: "Paris, France", lat: 48.8566, lng: 2.3522 },
  { name: "Istanbul, Turkey", lat: 41.0082, lng: 28.9784 },
  { name: "Amsterdam, Netherlands", lat: 52.3676, lng: 4.9041 },
  { name: "Lima, Peru", lat: -12.0464, lng: -77.0428 },
];

// Fallback stock images for the home "Moments captured" preview (until you upload your own).
export const GALLERY = [
  "https://images.unsplash.com/photo-1526772662000-3f88f10405ff?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1677690489325-e6a4d2594d76?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1759323346207-77411f41400c?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1690229378554-d4a0b22b4019?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1668428202528-bf3d5ed88560?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1652646611029-98a572deb519?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1504261025028-554905831f45?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1461838239441-4475121c0b7d?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1701906268419-b06b40559ad4?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1548850174-70a1cf2c5f09?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1534777367038-9404f45b869a?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1612352891598-639786f98b8f?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1690229927143-3d75d9ce962b?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1533396371595-d46b0aa39bd2?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1529733772151-bab41484710a?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1670871361579-54da7b070608?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1568607689150-17e625c1586e?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.pexels.com/photos/36927764/pexels-photo-36927764.jpeg?auto=compress&cs=tinysrgb&w=700",
  "https://images.unsplash.com/photo-1569070588058-73226af9d6d2?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
  "https://images.unsplash.com/photo-1506138979136-a74b54936c90?crop=entropy&cs=srgb&fm=jpg&q=80&w=700",
];

export const PHILOSOPHY = [
  {
    title: "Freedom",
    text: "I live on my own terms, and never let fear choose the road for me. As a child, I had to follow sick people who cut my wings. Now, I believe in freedom more than ever. To be who I am, not who the world told me to be. To do what I feel, not what people told me would be accepted. My way is my way—often misunderstood. Always remember, you can choose. And the choice can always be yours.",
  },
  {
    title: "Love",
    text: "The quiet force behind everything. I try to meet every person, place and moment with an open heart. Love, to me, is the deepest form of art. I know of no other force more powerful than it, and... it lies inside my heart. Everything I did, i do, or i will is out of love and with love. Love is the only word, the closest word, that can describe my essence. Because i am... love.",
  },
  {
    title: "The power of not judging",
    text: "I don't live my life constantly passing judgment. I look at people, the world, and experiences exactly as they are, without labeling them as good or bad. This is my way of opening up space around me for people—a space where you can breathe freely, without the fear of being judged. You can just be... you.",
  },
];
